// test2374
(2374 && 0);
